module.exports = __webpack_public_path__ + "static/img/CI.d45500a9.svg";